<template>
  <div class="manage-banner">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tiêu đề" prop="title">
          <a-input v-model="form.title" placeholder="Tiêu đề" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Nội dung" prop="description">
          <a-input
            type="textarea"
            :rows="5"
            v-model="form.description"
            placeholder="Nội dung"
          />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Keyword" prop="keyword">
          <a-input
            v-model="form.keyword"
            placeholder="Keyword hiển thị chữ chạy animation"
          />
        </a-form-model-item>
        <!-- <a-form-model-item class="mb-30" label="Ảnh" :colon="false">
          <input
            type="file"
            accept="image/png, image/svg, image/jpeg, image/gif, image/jpg"
            @change="onAvatarChange"
          />
        </a-form-model-item>
        <img
          v-show="avatarUrl"
          id="preview-avatar"
          :src="avatarUrl"
          class="preview-avatar"
        /> -->
        <a-form-model-item class="mt-50">
          <a-row type="flex" justify="end">
            <a-button
              type="primary"
              :loading="callingAPI"
              @click="handleSubmit"
            >
              {{ form.id ? "Cập nhật" : "Thêm mới" }}
            </a-button>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import {
  fetchBanner,
  updateBanner,
  createBanner,
} from "@/services/landing-page/home/banner";
export default {
  name: "HomeBanner",
  data() {
    return {
      callingAPI: false,
      form: {
        id: null,
        title: "",
        description: "",
        keyword: "",
        image: null,
        status: 1,
      },
      rules: {
        title: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        description: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        keyword: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
      },
      avatarUrl: "",
    };
  },
  beforeMount() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const params = {
          per_page: 1,
        };
        const response = await fetchBanner(params);
        if (response.data.data.length) {
          this.form.id = response.data.data[0].id;
          this.form.title = response.data.data[0].title;
          this.form.description = response.data.data[0].description;
          this.form.status = response.data.data[0].status
          this.form.keyword = response.data.data[0].keyword
          this.avatarUrl = response.data.data[0].image;
        }
      } catch (error) {}
    },

    onAvatarChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.form.image = file;
        this.avatarUrl = URL.createObjectURL(file);
      }
    },

    async handleSubmit(e) {
      e.preventDefault();
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.callingAPI = true;

            const formData = new FormData();
            formData.append("title", this.form.title);
            formData.append("description", this.form.description);
            formData.append("keyword", this.form.keyword);
            formData.append("status", this.form.status);

            if (this.form.image) {
              formData.append("image", this.form.image);
            }

            if (this.form.id) {
              formData.append("_method", "PUT");
            }

            let response = null;
            if (this.form.id) {
              response = await updateBanner(this.form.id, formData);
            } else {
              response = await createBanner(formData);
            }
            if (response.status == 1) {
              const message = this.form.id
                ? "Cập nhật thành công."
                : "Thêm mới thành công.";
              this.$notification.success({
                message: "Thành công",
                description: message,
              });
            } else {
              this.$notification.error({
                message: "Thất bại",
                description: response.errors[0],
              });
            }
          } catch (error) {
            this.callingAPI = false;
            console.log(error);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#preview-avatar {
  max-width: 100%;
  object-fit: contain;
  display: block;
}
</style>